<span class="time-display" data-cy="recorder-time">{{timerValue | formatTime: 'timer'}}</span>
